var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index-container" }, [
    _c(
      "div",
      { staticStyle: { padding: "20px" }, attrs: { id: "pdf" } },
      [
        _vm._v(" 欢迎来到心体汇运动健康管理平台 "),
        _c("el-button", { on: { click: _vm.generateReport } }, [
          _vm._v("测试生成新报告")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }